import React, { useState } from "react";
import axios from "axios";
import styled from "styled-components";

const Container = styled.div`
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const Title = styled.h2`
  color: #2d3748;
  text-align: center;
  margin-bottom: 1.5rem;
  font-size: 1.8rem;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.8rem 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  margin-bottom: 1rem;
  transition: border-color 0.3s;
  
  &:focus {
    outline: none;
    border-color: #4299e1;
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
  }
`;

const Button = styled.button`
  background-color: #4299e1;
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;
  
  &:hover {
    background-color: #3182ce;
  }
  
  &:disabled {
    background-color: #a0aec0;
    cursor: not-allowed;
  }
`;

const Output = styled.div`
  margin-top: 2rem;
  padding: 1.5rem;
  background-color: #f7fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  white-space: pre-wrap;
  line-height: 1.6;
  color: #4a5568;
`;

const LoadingIndicator = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255,255,255,.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

function QuestionGenerator() {
  const [topic, setTopic] = useState("");
  const [output, setOutput] = useState("");
  const [loading, setLoading] = useState(false);

  const handleGenerate = async () => {
    if (!topic.trim()) return;
    
    setLoading(true);
    try {
      const response = await axios.post("http://localhost:5000/api/generate", { topic });
      setOutput(response.data.result);
    } catch (err) {
      console.error(err);
      alert("Error generating questions");
    }
    setLoading(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleGenerate();
    }
  };

  return (
    <Container>
      <Title>Generate Malayalam Questions</Title>
      
      <Input
        type="text"
        placeholder="Enter topic (e.g., Rivers in Kerala, History of Kochi, Famous Malayalam Authors...)"
        value={topic}
        onChange={(e) => setTopic(e.target.value)}
        onKeyPress={handleKeyPress}
      />
      
      <Button onClick={handleGenerate} disabled={loading || !topic.trim()}>
        {loading ? (
          <>
            <LoadingIndicator /> Generating...
          </>
        ) : "Generate Questions"}
      </Button>

      {output && (
        <Output>
          <h3 style={{ marginTop: 0, color: "#2d3748" }}>Generated Questions:</h3>
          {output}
        </Output>
      )}
    </Container>
  );
}

export default QuestionGenerator;